/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 17:32:08
 */
export default {
  namespaced: true,
  state: {
    leaderNameList: []
  },
  mutations: {
    leaderNameList(state, todo) {
      state.leaderNameList = todo;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/about.js